<template>
  <ubi-page-container>
    <template v-if="results.count > 0" v-slot:page-actions>
      <router-link :to="{ name: 'portals-posts' }" class="inline" v-if="!user.roles.includes('ROLE_SUB_USER')">
        <el-button  type="warning">
                    <span @click="eventAnalytics('diffuser_annonces')">
                       {{ $t("portals.list.diffuseMyAds") }}
                    </span>
        </el-button>
      </router-link>

      <el-button
          type="primary"
          class="inline"
          @click="resetFiltersAndFetch"
          v-if="hasDiffusion && !showAllPortalsView"
      >
				<span @click="eventAnalytics('catalogue_portails')">
					{{ $t("portals.list.showAllPortals") }}
				</span>
      </el-button>
      
      <el-button
          type="primary"
          class="inline"
          @click="showActiveDiffusions"
          v-if="hasDiffusion && showAllPortalsView"
      >
				<span @click="eventAnalytics('retour_diffusions')">
					{{ $t("portals.list.returnToDiffusions") }}
				</span>
      </el-button>
    </template>
    <div v-loading="loading"
         :element-loading-text="$t('portals.list.chargementDonnees')">
      <el-form v-if="hasDiffusion || allPortals.count > 0" label-position="top" @submit.prevent.native="fetchList">
        <ubi-panel style="background-color: #EBF3F2;">
          <ubi-search-container
              ref="searchBlock"
              :filters="filters"
              :defaultFilter="this.filter.preset"
              v-on:resetfilter="resetFiltersAndFetch"
              @filter="doFilter"
              :more-opened="filter.advanced"
              @update:more-opened="advanced => setFilter({ advanced })"
          >
            <el-col :lg="10" v-if="nbStocks > 1">
              <el-form-item :label="$t('general.filters.stockSelection')">
                <el-select
                    v-model="filter.stock"
                    :placeholder="$t('general.filters.stockSelectionPlaceholder')"
                    clearable
                >
                  <el-option
                      v-for="stock in stocks"
                      :key="stock.id"
                      :label="upperCase(stock.nom)"
                      :value="stock.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-form-item :label="$t('general.filters.title')">
              <el-input
                  type="text"
                  @input="setSearch"
                  :value="filter.search"
                  :placeholder="$t('general.filters.titlePlaceholder')"
              />
            </el-form-item>
            <block-categories v-bind:excludedCategories="excludedCategories"></block-categories>
            <el-form-item :label="$t('general.filters.businessModel')">
              <el-radio-group :value="filter.gratuit" @input="setGratuit">
                <el-radio label="O" v-on:click.native="eventAnalytics('portails_gratuits')">
                  <span>{{ $t("general.filters.businessModelFree") }}</span>
                </el-radio>
                <el-radio label="N" v-on:click.native="eventAnalytics('portails_payants')">
                  <span>{{ $t("general.filters.businessModelPaid") }}</span>
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <template v-slot:more>
              <el-row style="background-color: #EBF3F2;margin-top: 15px;">
                <el-col :lg="12">
                  <el-form-item :label="$t('general.filters.quota')">
                    <el-radio-group :value="filter.quota" @input="quota => addFilter({ quota })">
                      <el-radio label="O">{{ $t("general.filters.quotaWith") }}</el-radio>
                      <el-radio label="N">{{ $t("general.filters.quotaWithout") }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :lg="12">
                  <el-form-item :label="$t('general.filters.dateDiffusion')">
                    <el-date-picker
                        type="daterange"
                        :value="filter.after || filter.before? [
                          filter.after || undefined,
                          filter.before || undefined
                        ] : null"
                        :start-placeholder="$t('general.filters.dateCreationStart')"
                        :end-placeholder="$t('general.filters.dateCreationEnd')"
                        @input="
                          dates => addFilter({ after: dates? dates[0] : null, before: dates? dates[1] : null})
                        "
                        format="dd/MM/yyyy"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
          </ubi-search-container>
          <el-dialog class="modificationQuotaModal" :visible.sync="modificationQuotaModal">
            <span slot="title" v-if="currentPortalQuota">{{
                $t("portals.list.dialogEditPostQuota")
              }} {{ currentPortalQuota.nom }}</span>
            <span v-if="currentPortalQuota && currentPortalQuota.modification_par_annonceur_autorisee == true">
                <el-form>
                  <el-radio-group v-model="choixModalQuota">
                  <el-row>
                    <el-col :md="24">
                      <el-radio label="turnoff">{{ $t("portals.list.doNotBroadcast") }}</el-radio>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :md="24">
                      <el-radio label="unlimited">{{ $t("portals.list.unlimited") }}</el-radio>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :md="14">
                      <el-radio label="limit">{{ $t("portals.list.limitedToXPosts") }} : </el-radio>
                    </el-col>
                    <el-col :md="4">
                      <el-input size="mini" max="4" v-if="currentPortalQuota && currentPortalQuota._embedded.diffusion"
                                v-model="limitQuota">{{ limitQuota }}</el-input>
                    </el-col>
                  </el-row>
                </el-radio-group>
                </el-form>
              </span>
            <span v-else>
                {{ $t("portals.list.contactBroadcasterToEditQuota") }}
              </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modificationQuotaModal = false">
                      <span @click="eventAnalytics('modale_modification_quota_fermer')">{{
                          $t("portals.list.close")
                        }}</span>
                   </el-button>
                <el-button type="primary" @click="modifierQuota">
                      <span>{{ $t("portals.list.confirm") }}</span>
                   </el-button>
              </span>
          </el-dialog>
          <el-dialog :visible.sync="modificationIdentifiantsModal">
            <span slot="title" v-if="currentPortal">{{ $t("portals.list.dialogEditIdentifiants") }} <span style="font-weight: bold;">{{ currentPortal.nom }}</span></span>
            <span v-if="identifiantsEditableAnnonceur">
                <el-form v-if="currentPortal && currentPortal._embedded.diffusion.identifiants">
                  <div v-for="identifiant in currentPortal._embedded.diffusion.identifiants" :key="identifiant.numero">
                    <el-row v-if="identifiant.editable_annonceur">
                      <el-col :md="6">{{ identifiant.libelle }}</el-col>
                      <el-col :md="6"><el-input type="text" size="mini" v-model="identifiant.valeur">{{ identifiant.valeur }}</el-input></el-col>
                    </el-row>
                    <br />
                  </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="modificationIdentifiantsModal = false">{{ $t("portals.list.close") }}</el-button>
                    <el-button type="primary" @click="modifierIdentifiants">{{ $t("portals.list.confirm") }}</el-button>
                </span>
              </span>
            <span v-else>
                <div>{{ $t("portals.list.aucunIdentifiantEditable") }}</div>
                <br />
                <span slot="footer" class="dialog-footer">
                    <el-button @click="modificationIdentifiantsModal = false">{{ $t("portals.list.close") }}</el-button>
                </span>
              </span>
          </el-dialog>
          <el-dialog class="SelectPortailPayantModal" :visible.sync="selectPortailPayant">
            <span slot="title" v-html="$t('portals.list.activationToPaidPortalTitle', {portal: nomPortail})"/>
            <span v-html="$t('portals.list.activationToPaidPortalText', {email: emailCommercialPortail})"/>
            <span slot="footer" class="dialog-footer">
                      <el-button type="primary" @click="selectPortailPayant = false">
                         <span @click="eventAnalytics('modale_diffusion_payante_fermer')">
                            {{ $t("portals.list.close") }}
                         </span>
                      </el-button>
                   </span>
          </el-dialog>
          <el-dialog
              class="ActivationPortailGratuit"
              :visible.sync="activationPortailModal"
              :title="$t('portals.list.activationResultTitle')"
          >
              <span>
                <div
                    v-if="activationPortail != null && activationPortail.reponse.messageHelper">{{ activationPortail.reponse.messageHelper }}</div>
                <div
                    v-if="activationPortail != null && activationPortail.reponse.detail">{{ activationPortail.reponse.detail }}</div>
              </span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="activationPortailModal = false">
                <span @click="eventAnalytics('modale_diffusion_gratuite_fermer')">
                   {{ $t("portals.list.close") }}
                </span>
             </el-button>
              </span>
          </el-dialog>

          <el-dialog
              v-if="impossibleToActivePortal"
              class="ConfirmDesactivationPortailModal"
              :title="$t('portals.list.impossibleToActiveModalTitle') + impossibleToActivePortal.nom"
              :visible.sync="showImpossibleToActivateModal"
          >
            <div>
              {{ $t("portals.list.impossibleToActiveModalText") }} <br>
              <span v-if="impossibleToActivePortal.email_equipe_commerciale">
                                 {{ $t("portals.list.mail") }} : {{ impossibleToActivePortal.email_equipe_commerciale }} <br>
                            </span>
              <span v-if="impossibleToActivePortal.telephone_equipe_commerciale">
                                 {{
                  $t("portals.list.tel")
                }} : {{ impossibleToActivePortal.telephone_equipe_commerciale }}
                            </span>
            </div>
            <span slot="footer" class="dialog-footer">
                            <el-button @click="showImpossibleToActivateModal = false">{{
                                $t("portals.list.confirm")
                              }}</el-button>
                        </span>
          </el-dialog>

          <el-dialog
              class="ConfirmDesactivationPortailModal"
              :title="$t('portals.list.deactivateDiffusionTitle')"
              :visible.sync="confirmDesactivationPortailModal"
          >
            <span>{{ $t("portals.list.deactivateDiffusionText") }}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmDesactivationPortailModal = false">{{ $t("portals.list.cancel") }}</el-button>
                <el-button type="primary"
                           @click="desactiverPortail(nomCodePortail)">{{ $t("portals.list.confirm") }}</el-button>
              </span>
          </el-dialog>
          <el-dialog
              class="DesactivationPortailModalResult"
              :title="$t('portals.list.deactivateDiffusionTitle')"
              :visible.sync="desactivationPortailModal"
          >
              <span>
                <div>{{ $t("portals.list.result") }} :</div>
                <div v-if="desactivationPortail != null">
                  <span v-html="desactivationPortail.reponse.success"></span>
                </div>
              </span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary"
                           @click="desactivationPortailModal = false">{{ $t("portals.list.close") }}</el-button>
              </span>
          </el-dialog>
          <el-dialog
              class="BouquetActiveModal"
              :title="$t('portals.list.activationResultUbiflowPackageTitle')"
              :visible.sync="bouquetActivated"
          >
              <span v-if="activation != null">
                <h3>{{ $t("portals.list.activationResultUbiflowPackageAdded") }} :</h3>
                <div v-for="message in activation.messages.messages" v-bind:key="message">- {{ message }}</div>
              </span>
            <br/>
            <span v-if="activation != null">
                <h3>{{ $t("portals.list.activationResultUbiflowPackageRemoved") }} :</h3>
                <div v-for="erreur in activation.messages.erreurs" v-bind:key="erreur">- {{ erreur }}</div>
              </span>
            <br><br>
            <p>{{ $t("portals.list.activationResultUbiflowPackageMessage") }}</p>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="bouquetActivated = false">{{ $t("portals.list.close") }}</el-button>
              </span>
          </el-dialog>
        </ubi-panel>
        <ubi-panel class="PortalsList" :full-width="browserContext.up('lg')">
          <template slot="header">
            <ubi-list-header
                slot="header"
                :limits="[8, 16, 32]"
                :page.sync="page"
                :limit.sync="limit"
                :total="results.total"
                :sort.sync="sort"
                :sortProperties="sortProperties"
            ></ubi-list-header>
          </template>
          <template slot="selection">
            <ubi-list-selection
                slot="selection"
                v-model="selected"
                @select="doSelect"
                arrow-down
            />
          </template>
          <template slot="actions">
            <el-button
                icon="export"
                size="mini"
                @click="exporter"
            >{{ $t("portals.list.exportResults") }}
            </el-button>
          </template>
          <ubi-list-footer
              slot="footer"
              :limits="[8, 16, 32]"
              :page.sync="page"
              :limit.sync="limit"
              :total="results.total"
          ></ubi-list-footer>
          <!-- PC : Affichage du tableau en version bureau -->
          <el-table
              ref="tablePortalsList"
              :data="results.list"
              v-if="browserContext.up('lg')"
              @select="selectedChanged"
              @select-all="selectAllChanged"
          >
            <el-table-column fixed type="selection" width="88"/>
            <el-table-column fixed :label="$t('portals.list.columnActivate')" min-width="65">
              <template v-slot="{ row: result }">
                <em class="el-icon-success text-success mr-2" style="font-size:1.9em;"
                    v-if="result._embedded && result._embedded.diffusion && result._embedded.diffusion.active"/>
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.columnLogo')" min-width="120">
              <template v-slot="{ row: result }">
                <img
                    alt=""
                    width="70"
                    :src="result.logo"
                    :srcset="result.logo"
                />
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.columnPortal')" min-width="250">
              <template v-slot="{ row: result }">
                                <span v-if="result.prive === false">
                                    <el-link
                                        target="_blank" rel="noopener"
                                        :href="result.lienSiteUbiflow"
                                    > {{ result.nom }}
                                    </el-link>
                                </span>
                <span v-else>
                                    {{ result.nom }}
                                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.selectedAds')" min-width="155" v-if="isMainAccount || isSubAdmin || !quotaPersonnel">
              <template v-slot="{ row: result }">
                <div v-if="result._embedded && !result._embedded.diffusion">
                  {{ result._embedded.diffusion.nbAnnoncesSelectionnees }}
                  <el-tooltip placement="top-start">
                    <div slot="content">{{ $t('portals.broadcast.tooltipSelectedAdsPortals') }}</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else-if="result._embedded && result._embedded.diffusion.nbAnnoncesMax > 0">
                  {{ result._embedded.diffusion.nbAnnoncesSelectionnees }}
                  <el-tooltip placement="top-start">
                    <div slot="content">{{ $t('portals.broadcast.tooltipSelectedAdsPortals') }}</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else></div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.statutDIff')" min-width="80" v-if="isMainAccount || isSubAdmin || !quotaPersonnel">
              <template v-slot="{ row: result }">
                <div v-if="quotaPerUser">
                  <div v-if="result._embedded && result._embedded.diffusion.nbAnnoncesQuota != 0 && userQuotaPerPortal[result._embedded.diffusion.id]">
                    {{ $t("portals.list.limitedTo") }} {{ userQuotaPerPortal[result._embedded.diffusion.id].reponse }}
                  </div>
                  <div v-else-if="result._embedded && result._embedded.diffusion.nbAnnoncesQuota == 0">
                    <div>{{ $t('portals.list.unlimited') }}</div>
                  </div>
                  <div v-else>-</div>
                </div>
                <div v-else>
                  <div v-if="result._embedded && result._embedded.diffusion.nbAnnoncesQuota != 0">
                    <div>{{ $t("portals.list.limitedTo") }} {{ result._embedded.diffusion.nbAnnoncesQuota }}
                    </div>
                  </div>
                  <div v-else-if="result._embedded && result._embedded.diffusion.nbAnnoncesQuota == 0">
                    <div>{{ $t('portals.list.unlimited') }}</div>
                  </div>
                  <div v-else>-</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.numberOfSelectedPrograms')" min-width="235" v-if="sitimmoUser.metier === 'PROMOTEUR'">
              <template v-slot="{row: result}">
                <div style="text-align: center" v-if="result._embedded && result._embedded.diffusion">{{result._embedded.diffusion.nbAnnoncesSelectionneesProgrammes}}</div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.selectedAds')" min-width="100" v-if="quotaPersonnel && (!isMainAccount && !isSubAdmin)">
              <template v-slot="{ row: result }">
                <div v-if="result._embedded && result._embedded.diffusion && usersPortailsQuotas[result._embedded.diffusion.id] && usersPortailsQuotas[result._embedded.diffusion.id].userPosts">
                  {{ usersPortailsQuotas[result._embedded.diffusion.id].userPosts }}
                  <el-tooltip placement="top-start">
                    <div slot="content">{{ $t('portals.broadcast.tooltipSelectedAdsPortals') }}</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else-if="result._embedded && result._embedded.diffusion && result._embedded.diffusion.nbAnnoncesMax > 0">
                  {{ annonceSelectionneeForPortail[result._embedded.diffusion.id] }}
                  <el-tooltip placement="top-start">
                    <div slot="content">{{ $t('portals.broadcast.tooltipSelectedAdsPortals') }}</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else></div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.quotaPerso')" min-width="120" v-if="quotaPersonnel">
              <template v-slot="{ row: result }">
                <div v-if="result._embedded && result._embedded.diffusion.nbAnnoncesQuota != 0">
                  <div v-if="usersPortailsQuotas[result._embedded.diffusion.id]">{{ $t("portals.list.limitedTo") }} {{ usersPortailsQuotas[result._embedded.diffusion.id].userQuota }}</div>
                  <div v-else>{{ $t("portals.list.limitedTo") }} 0</div>
                </div>
                <div v-else-if="result._embedded && result._embedded.diffusion.nbAnnoncesQuota == 0">
                  <div>{{ $t('portals.list.unlimited') }}</div>
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.columnSelectAds')" min-width="200" align="center">
              <template v-slot="{ row: result }">
                <router-link v-if="result._embedded && result._embedded.diffusion.active === true" :to="{ name: 'broadcast', params: { portal: result._embedded.diffusion.id } }">
                  <em @click="eventAnalytics('selection_annonces')" class="el-icon-edit"></em>
                </router-link>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" :label="$t('portals.list.columnActions')"  min-width="120">
              <template v-slot="{ row: result }">
                <el-dropdown class="inline">
                  <el-button size="mini" icon="more" type="success" @click.prevent.native="" v-if="result._embedded && result._embedded.diffusion.active === true"></el-button>
                  <el-button size="mini" icon="more" v-else></el-button>
                  <el-dropdown-menu slot="dropdown">
                    <router-link v-if="result._embedded" v-on:click.native="eventAnalytics('rapport_diffusion')" :to="{ name: 'report', params: { portal: result.nom_de_code } }">
                      <el-dropdown-item>{{ $t("portals.list.actionReport") }}</el-dropdown-item>
                    </router-link>
                    <el-dropdown-item v-if="result._embedded && result._embedded.diffusion.active === true && result.modification_par_annonceur_autorisee === true && !isSubUser">
                      <span @click="modifierQuotaModal(result)">
                        {{ $t("portals.list.editQuota") }}
                      </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="result._embedded && result._embedded.diffusion.active === true && result.modification_par_annonceur_autorisee === true && !isSubUser">
                      <span @click="modifierIdentifiantsModal(result)">
                        {{ $t("portals.list.editIdentifiants") }}
                      </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="sitimmoUser.immowebUrlConnexion && ((result.nom_de_code == 'IMMOWEB') || (result.nom_de_code == 'IMMOWEB_API') )">
                      <a v-bind:href="sitimmoUser.immowebUrlConnexion" target="_blank">{{ $t("portals.list.immowebUrlConnexion") }}</a>
                    </el-dropdown-item>
                    <el-dropdown-item divided v-if="result._embedded && result._embedded.diffusion.active === true && !user.roles.includes('ROLE_SUB_USER')">
                      <span class="text-danger" @click="{ confirmDesactivationPortailModal = true, nomCodePortail = result.nom_de_code }">
                        <ubi-icon name="trash"/>{{ $t("portals.list.actionSuspend") }}</span>
                    </el-dropdown-item>
                    <el-dropdown-item divided v-else-if="!user.roles.includes('ROLE_SUB_USER')">
                      <span @click="activerPortailGratuit(result)" class="text-success">{{ $t("portals.list.actionActivate") }}</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <!-- MOBILE : Affichage du tableau en mode responsive -->
          <ubi-card-container :data="results.list" v-loading.fullscreen.lock="loading" :element-loading-text="$t('portals.list.chargementDonnees')" v-else>
            <template v-slot="{ row: result }">
              <ubi-card v-model="selected" :label="String(result.id)">
                <template slot="header">
                  <div style="text-align: center;">
                    <img
                        alt=""
                        width="50%"
                        :src="result.logo"
                        :srcset="result.logo"
                    />
                  </div>
                </template>
                <el-row type="flex" justify="space-between">
                  <el-col :span="null">
                    <h3>{{result.name}}</h3>
                  </el-col>
                  <el-col :span="null">{{result.categorie}}</el-col>
                </el-row>
                <el-row type="flex" justify="space-between">
                  <el-col :span="null" v-if="result._embedded">
                    <small class="text-muted">{{ $t('portals.list.columnAds') }} :</small>
                    <div v-if="quotaPersonnel && (isMainAccount || isSubAdmin) && result._embedded && result._embedded.diffusion.nbAnnoncesMax > 0" >
                      {{result._embedded.diffusion.nbAnnoncesSelectionnees}}
                    </div>
                    <div v-else-if="quotaPersonnel && !isMainAccount && !isSubAdmin && result._embedded && result._embedded.diffusion.nbAnnoncesMax > 0" >
                      {{ annonceSelectionneeForPortail[result._embedded.diffusion.id] }}
                    </div>
                    <div v-else-if="!quotaPersonnel && result._embedded && !result._embedded.diffusion">
                      {{result._embedded.diffusion.nbAnnoncesSelectionnees}}
                    </div>
                    <div v-else-if="result._embedded && result._embedded.diffusion.nbAnnoncesMax > 0">
                      {{result._embedded.diffusion.nbAnnoncesSelectionnees}}
                    </div>
                    <div v-else></div>
                  </el-col>
                </el-row>
                <div class="pt-2">
                  <small class="text-muted">{{ $t('portals.list.columnLastDiffusion') }} :</small>
                  <div
                      v-if="result.dateDernierEnvoi != null && result._embedded"
                  >{{formatDate(result._embedded.diffusion.dateDernierEnvoi)}} ?
                    {{formatHeure(result._embedded.diffusion.dateDernierEnvoi)}}
                  </div>
                  <div v-else>-</div>
                </div>
                <div class="pt-3">
                  <el-button
                      :to="{ name: 'broadcast', params: { portal: result._embedded.diffusion.id } }"
                      size="mini"
                      type="warning"
                      class="inline"
                      v-if="result._embedded && result._embedded.diffusion.active == true"
                  >{{ $t('portals.list.buttonAds') }}
                  </el-button>
                  <el-button
                      size="mini"
                      type="success"
                      plain
                      class="inline"
                      @click="activerPortailGratuit(result)"
                      v-else-if="(result._embedded && result._embedded.diffusion.active == false) || result.modeleEconomique == 'gratuit'"
                  >{{ $t('portals.list.buttonActivate') }}
                  </el-button>
                  <el-button
                      size="mini"
                      type="success"
                      plain
                      class="inline"
                      @click="{ selectPortailPayant = true, nomPortail= result.nom, nomCodePortail = result.nom_de_code, emailCommercialPortail = result.email_equipe_commerciale }"
                      v-else
                  >{{ $t('portals.list.buttonActivate') }}
                  </el-button>
                  <el-dropdown class="inline">
                    <el-button size="mini" icon="more"></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <router-link
                          v-if="result._embedded"
                          v-on:click.native="eventAnalytics('rapport_diffusion')"
                          :to="{ name: 'report', params: { portal: result.nom_de_code } }"
                      >
                        <el-dropdown-item>{{ $t("portals.list.actionReport") }}</el-dropdown-item>
                      </router-link>
                      <el-dropdown-item divided
                                        v-if="result._embedded && result._embedded.diffusion.active == true">
                          <span
                              class="text-danger"
                              @click="{ confirmDesactivationPortailModal = true, nomCodePortail = result.nom_de_code }"
                          >
                            <ubi-icon name="trash"/>
                            {{ $t("portals.list.actionSuspend") }}
                          </span>
                      </el-dropdown-item>
                      <el-dropdown-item divided v-else>
                                     <span @click="activerPortailGratuit(result)"
                                           class="text-success">{{ $t("portals.list.actionActivate") }}</span>
                      </el-dropdown-item>
                      <el-dropdown-item><span
                          @click="modifierQuotaModal(result)">Modifier le quota</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </ubi-card>
            </template>
          </ubi-card-container>
        </ubi-panel>
      </el-form>
      <ubi-panel v-else>
        <h1>{{ $t('portals.list.noDiffusionTitle') }}</h1>
        <div style="margin-left: 5%; margin-right: 5%;">
          <h3 class="text-center">
            <strong>{{ $t('portals.list.noDiffusionText1') }}</strong>
          </h3>
          <br/><br/>
          <h3>{{ $t('portals.list.noDiffusionText2') }}</h3>
          <p class="text-justify" v-html="$t('portals.list.noDiffusionText3')"/>
          <br/>
          <h3>{{ $t('portals.list.noDiffusionText4') }}</h3>
          <p class="text-justify" v-html="$t('portals.list.noDiffusionText5')"/>
          <br/>
          <h3>{{ $t('portals.list.noDiffusionText6') }}</h3>
          <p class="text-justify" v-html="$t('portals.list.noDiffusionText7')"/>
          <br/>
          <h3>{{ $t('portals.list.noDiffusionText8') }}</h3>
          <p class="text-justify" v-html="$t('portals.list.noDiffusionText9')"/>
          <br/>
          <h3>{{ $t('portals.list.noDiffusionText10') }}</h3>
          <p class="text-justify">
            {{ $t('portals.list.noDiffusionText11') }}
            <a href="https://www.ubiflow.mx/" target="_blank" rel="noopener">
              Contact Manager
            </a>
            <span v-html="$t('portals.list.noDiffusionText12')"/>
            <br><br>
            {{ $t('portals.list.noDiffusionText13') }}
          </p>
        </div>
        <br/>
        <br/>
        <div class="text-center">
          <el-row>
            <el-button @click="send">{{ $t("dashboard.beContacted") }}</el-button>
          </el-row>
          <br/>
          <el-row>
            <el-button type="primary" @click="eventAnalytics('decouvrir_produit')"><a :href="discoverProductLink"
                                                                                      target="_blank" rel="noopener"
                                                                                      id="lienBouton2">{{
                $t("dashboard.decouvrir")
              }}</a>
            </el-button>
          </el-row>
        </div>
      </ubi-panel>
    </div>
  </ubi-page-container>
</template>
<style lang="scss">
@import "@/theme/_bootstrap.scss";

.tralalaPouet {
  background-color: #1e4a56;
}

.PortalsList {
  &-selection {
    @extend .mb-5;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  @include media-breakpoint-down(md) {
    &-selection {
      flex-direction: column;
      align-items: flex-start;
    }
    &-export {
      align-self: flex-end;
    }
  }
}

.BouquetActiveModal {
  &-dialog .el-dialog {
    width: 670px;
    max-width: 90%;
  }

  &-container {
    > *:not(:first-child) {
      border-left: 1px solid $gray-200;
    }
  }

  &-actions {
    text-align: right;
  }
}

.el-loading-spinner {
  top: 10% !important;
}
</style>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import moment from 'moment'
import {
  activerDiffusionAnnonceur,
  desactiverDiffusionAnnonceur,
  exportCsvAllPortails,
  modificationQuotaAnnonces,
  getAllPortals,
  remonterAnnoncesTeteDeListe,
  getUserQuotaPerPortal,
  getDiffusionAnnonceByAnnonceForPortal, getUsersPortailsQuotas, modificationIdentifiants, diffusionsAnnonces

} from '../../services/portals'
import { Dialog } from 'element-ui'
import blockCategories from './components/Categories'
import _uniq from 'lodash/uniq'
import { sendEmail } from '../../services/email'
import {
  getPosts
} from '@/services/posts'
import UbiPanel from "@/components/Panel.vue";
import UbiSearchContainer from "@/components/SearchContainer.vue";

const axios = require('axios')
export default {
  name: 'PortalsList',
  inject: ['browserContext'],
  components: {UbiSearchContainer, UbiPanel, ElDialog: Dialog, blockCategories },
  data () {
    return {
      loading: false,
      dialogVisible: false,
      quotaPerUser: false,
      quotaPersonnel: false,
      bouquetActivated: false,
      diffDateSemaineDerniereRemonteeTeteDeListe: 0,
      currentPortalQuota: null,
      currentPortal: null,
      activation: null,
      activationPortail: null,
      activationPortailModal: false,
      confirmDesactivationPortailModal: false,
      desactivationPortailModal: false,
      desactivationPortail: null,
      remontee: null,
      messageRemontee: null,
      allPortals: [],
      annonceSelectionneeForPortail: [],
      modificationQuotaModal: false,
      modificationIdentifiantsModal: false,
      identifiantsEditableAnnonceur: false,
      identifiantsValeurs: {},
      limits: [10, 10 * 2, 10 * 5],
      selected: [],
      allPortalsSelected: [],
      nbAnnoncesSelectionneesForUser: [],
      nbAnnoncesActiveForUser: 0,
      selectPortailPayant: false,
      selectPortailPayantResultat: false,
      nomCodePortail: null,
      emailCommercialPortail: 'test@test.com',
      nomPortail: null,
      choixModalQuota: 'turnoff',
      limitQuota: 0,
      portailIsPayant: null,
      info: '',
      file: null,
      userQuotaPerPortal: [],
      showAllPortalsView: false,
      sortProperties: {
        nom: this.$t('general.sort.name'),
        date: this.$t('general.sort.lastDiffusion'),
        annonces: this.$t('general.sort.ads')
      },
      filters: [
        { value: 'reset', label: this.$t('general.filters.allPortals') },
        { value: 'active', label: this.$t('general.filters.activePortals') },
        { value: 'inactive', label: this.$t('general.filters.inactivePortals') }
      ],
      selection: null,
      showImpossibleToActivateModal: false,
      impossibleToActivePortal: null,
      usersPortailsQuotas: {},
      excludedCategories: 'réseaux sociaux,biens vendus'
    }
  },
  computed: {
    ...mapGetters(['isMainAccount', 'isSubAdmin', 'isSubUser', 'getPickerOptionsShortcuts']),
    ...mapGetters('productLine', ['hasDiffusion']),
    ...mapState('portals', ['filter', 'results']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeContactManager () {
      return this.sitimmoUser.possede_contact_manager
    },
    universe () {
      return this.sitimmoUser.univers
    },
    nbStocks () {
      return this.sitimmoUser.stocks.length
    },
    stocks () {
      return this.sitimmoUser.stocks
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    page: {
      get () {
        return this.filter.page
      },
      async set (value) {
        window.scrollTo(0, 0)
        this.setPage(value)
        await this.fetchList()
        this.toggleSelection()
        // return this.setPage(value);
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      async set (value) {
        this.setLimit(value)
        await this.fetchList()
        return this.setLimit(value)
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      async set (value) {
        this.setSort(value)
        await this.fetchList()
        return this.setSort(value)
      }
    },
    discoverProductLink () {
      if (this.universe === 'IMMO') {
        return 'https://www.ubiflow.net/solutions-diffusion-immo.php'
      } else {
        return 'https://www.ubiflow.net/solutions-diffusion-auto.php'
      }
    }
  },
  beforeMount () {
    this.loading = true
    if (!this.hasDiffusion) {
      this.resetFilter()
      this.fetchList()
    }
  },
  mounted () {
    this.loading = true
    if (this.possedeContactManager === false) {
      delete this.sortProperties.contact
    }
  },
  methods: {
    eventAnalytics (category) {
      this.$ga.event('liste_diffusions', 'clic', category, this.sitimmoUser.id)
    },
    async exporter () {
      let i = 0
      let strSelectedIds = null
      this.selected.forEach(function (idSelected) {
        if (i === 0) {
          strSelectedIds = idSelected
        } else {
          strSelectedIds = strSelectedIds + ',' + idSelected
        }
        i++
      })
      this.loading = true
      const filename = this.$t('portals.list.filenameExportDiffusions')
      const res = await exportCsvAllPortails(this.filter, strSelectedIds, false, filename)
      this.$message(res)
      this.loading = false
    },
    convertDate: function (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    ...mapMutations('portals', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setCategory',
      'setGratuit',
      'setFilter',
      'addFilter',
      'setResults',
      'setQuota',
      'setAfter',
      'setBefore',
      'resetFilter',
      'setStock'
    ]),
    async fetchList () {
      this.loading = true
      this.filter.excludedCategories = this.excludedCategories
      this.allPortals = await getAllPortals(this.filter)
      if (this.allPortals.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      // QUOTA :
      if ((this.user.identifierValue != null) && (this.user.identifierCode != null)) {
        await this.chargementDonneesQuotas()
      }
      this.loading = false
      this.setResults(this.allPortals)
    },
    resetFiltersAndFetch () {
      this.resetFilter()
      this.showAllPortalsView = true
      this.fetchList()
    },
    async chargementDonneesQuotas () {
      this.quotaPersonnel = true
      // Quotas users
      const resultUsersPortailsQuotas = await getUsersPortailsQuotas()
      for (let i = 0; i < resultUsersPortailsQuotas.length; i++) {
        const usersPortail = resultUsersPortailsQuotas[i]
        for (let j = 0; j < usersPortail.usersQuotas.length; j++) {
          const userQuotas = usersPortail.usersQuotas[j]
          if (userQuotas.userId == this.user.id) {
            this.usersPortailsQuotas[usersPortail.diffusionId] = userQuotas
          }
        }
      }
      // Annonces sélectionnées
      for (let i = 0; i < this.allPortals.results.length; i++) {
        const portail = this.allPortals.results[i]
        if (this.usersPortailsQuotas[portail._embedded.diffusion.id]) {
          this.annonceSelectionneeForPortail[portail._embedded.diffusion.id] = this.usersPortailsQuotas[portail._embedded.diffusion.id].userPosts
        } else if (portail._embedded.diffusion.nbAnnoncesQuota === 0) {
          const filters = {}
          filters.diffuseurCode = portail.nom_de_code
          const diffusions = diffusionsAnnonces(filters)
          this.annonceSelectionneeForPortail[portail._embedded.diffusion.id] = diffusions.length
        } else {
          this.annonceSelectionneeForPortail[portail._embedded.diffusion.id] = portail._embedded.diffusion.nbAnnoncesSelectionnees
        }
      }
    },
    async modifierQuotaModal (result) {
      this.modificationQuotaModal = true
      this.currentPortalQuota = result
      if (result._embedded) {
        this.limitQuota = result._embedded.diffusion.nbAnnoncesQuota
        if (this.limitQuota === 0) {
          this.choixModalQuota = 'unlimited'
        } else {
          this.choixModalQuota = 'limit'
        }
      }
    },
    async modifierQuota () {
      if (this.choixModalQuota == 'turnoff') {
        this.desactivationPortail = await desactiverDiffusionAnnonceur(this.currentPortalQuota.nom_de_code)
        this.modificationQuotaModal = false
        this.desactivationPortailModal = true
      }
      if (this.choixModalQuota == 'unlimited') {
        this.desactivationPortail = await modificationQuotaAnnonces(this.currentPortalQuota.nom_de_code, 0)
      }
      if (this.choixModalQuota == 'limit') {
        this.desactivationPortail = await modificationQuotaAnnonces(this.currentPortalQuota.nom_de_code, this.limitQuota)
      }
      this.modificationQuotaModal = false
      this.fetchList()
    },
    async modifierIdentifiantsModal (result) {
      this.modificationIdentifiantsModal = true
      this.currentPortal = result
      this.identifiantsEditableAnnonceur = false
      for (const numero in this.currentPortal._embedded.diffusion.identifiants) {
        const identifiant = this.currentPortal._embedded.diffusion.identifiants[numero]
        if (identifiant.editable_annonceur === true) {
          this.identifiantsEditableAnnonceur = true
        }
      }
    },
    async modifierIdentifiants () {
      const identifiants = []
      for (const numero in this.currentPortal._embedded.diffusion.identifiants) {
        const identifiant = this.currentPortal._embedded.diffusion.identifiants[numero]
        if (identifiant.editable === true) {
          identifiants[identifiant.numero] = identifiant.valeur
        }
        if (identifiant.caracteristique_annonceur && !identifiant.valeur) {
          this.identifiantsErreurs.push(identifiant.numero)
        }
      }
      modificationIdentifiants(this.currentPortal._embedded.diffusion.id, identifiants)
      this.modificationIdentifiantsModal = false
    },
    formatDate: function (date) {
      return date ? date.substring(0, 10) : null
    },
    async activerPortailGratuit (portal) {
      if (portal.modification_par_annonceur_autorisee === false) {
        this.showImpossibleToActivateModal = true
        this.impossibleToActivePortal = portal
        return false
      }

      this.activationPortail = await activerDiffusionAnnonceur(portal.nom_de_code)
      if (this.activationPortail.type == 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.activationPortailModal = true
    },
    async desactiverPortail (nomCodePortail) {
      this.confirmDesactivationPortailModal = false
      this.desactivationPortail = await desactiverDiffusionAnnonceur(nomCodePortail)
      if (this.desactivationPortail.type == 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.desactivationPortailModal = true
    },
    formatHeure: function (date) {
      return date ? date.substring(10, 16) : null
    },
    doFilter (type) {
      this.filter.preset = type
      this.filter.page = 1
      switch (type) {
        case 'reset':
          this.filter.active = null
          this.filter.diffuseurCodeNames = null
          this.setFilter(this.filter)
          break
        case 'active':
          this.filter.active = true
          this.filter.diffuseurCodeNames = null
          this.setFilter(this.filter)
          break
        case 'inactive':
          this.filter.active = false
          this.filter.diffuseurCodeNames = null
          this.setFilter(this.filter)
          break
      }
      this.fetchList()
    },
    doSelect (type) {
      switch (type) {
        case '*':
          const tmpSelection = this.results.list.map(({ id }) => id)
          this.selected = _uniq(this.selected.concat(tmpSelection))
          this.toggleSelection()
          // this.$refs.tablePortalsList.toggleAllSelection();
          break
        case null:
        default:
          this.selected = []
          // this.selection = "";
          this.$refs.tablePortalsList.clearSelection()
      }
    },
    toggleSelection () {
      this.results.list.forEach(row => {
        if (this.selected.includes(row.id)) {
          this.$refs.tablePortalsList.toggleRowSelection(row, true)
        }
      })
    },
    selectAllChanged (selection) {
      // unselect all case
      if (!selection.length) {
        const self = this
        this.results.list.forEach(function (item) {
          const index = self.selected.indexOf(item.id)
          if (index > -1) {
            this.selected.splice(index, 1)
          }
        }, self)
        // this.$refs.tablePortalsList.clearSelection();
      } else { // select all case
        this.doSelect('*')
      }
    },
    selectedChanged (selection, row) {
      let add = false
      selection.forEach(function (item) {
        if (item.id === row.id) {
          add = true
        }
      })
      const index = this.selected.indexOf(row.id)
      if (add) {
        if (index === -1) {
          this.selected.push(row.id)
        }
      } else {
        if (index > -1) {
          this.selected.splice(index, 1)
        }
      }
    },
    upperCase (string) {
      if (!string) return ''
      return string.charAt(0).toUpperCase() + string.substr(1)
    },
    async send () {
      this.eventAnalytics('etre_contacte')
      this.loading = true
      this.sendTo = processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_MARKETING
      const mailData = {
        to: this.sendTo,
        subject: 'Client ' + this.sitimmoUser.login + ' : Diffusion - Demande de contact',
        content: 'Le client ' + this.sitimmoUser.login + '(' + this.sitimmoUser.nom + ') a fait une demande de contact sur le nouvel espace client pour la solution "Diffusion". Vous pouvez le recontacter via ' + this.sitimmoUser.email + ' ou au numéro ' + this.sitimmoUser.telephone
      }
      const response = await sendEmail(mailData)
      if (response.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.loading = false
      window.alert('Vous souhaitez des informations sur notre produit Diffusion. Notre équipe va prendre contact avec vous dans les meilleurs délais')
      // self.$message(response);
    },
    showActiveDiffusions () {
      this.resetFilter()
      this.filter.active = true
      this.showAllPortalsView = false
      this.fetchList()
    }
  }
}
</script>
<style>
#lienBouton2 {
  color: white;
  text-decoration: none;
}
</style>
